const useAPI = () => {

    enum HttpMethod {
        Post    = "POST",
        Get     = "GET",
        Put     = "PUT",
        Delete  = "DELETE"
    };

    const generateUrlParams = (method: HttpMethod, values: any) : string => {
        if (method === HttpMethod.Get || method === HttpMethod.Delete) {
            if ((values !== '')) {
                return new URLSearchParams(values).toString();
            } else {
                return '';
            };  
        } else { return '' };
    };

    const post = async (endpoint: string, values: any, encodeValues: boolean = true, json: boolean = true, customHeaders?: object) => {
        return call(HttpMethod.Post, endpoint, values, encodeValues, json, customHeaders);
    };

    const get = async (endpoint: string, values: any, encodeValues: boolean = true, customHeaders?: object) => {
        return call(HttpMethod.Get, endpoint, values, encodeValues, true, customHeaders);
    };

    const put = async (endpoint: string, values: any, encodeValues: boolean = true) => {
        return call(HttpMethod.Put, endpoint, values, encodeValues);
    };

    const del = async (endpoint: string, values: any, encodeValues: boolean = true) => {
        return call(HttpMethod.Delete, endpoint, values, encodeValues);
    };

    const call = async (
        method: HttpMethod, 
        endpoint: string, 
        values: any, 
        encodeValues: boolean, 
        json: boolean = true,
        customHeaders?: object
    ) => {
        let errors = false;
        let returnValue;
        let paramUrl = encodeValues ? generateUrlParams(method, values) : values;

        // Header set Access-Control-Allow-Methods: DELETE, POST, GET, OPTIONS, PUT
        // Header set Access-Control-Allow-Headers: Content-Type, Authorization, X-Requested-With

        if (method === HttpMethod.Get || method === HttpMethod.Delete) {
            return fetch(`${process.env.REACT_APP_API}/${endpoint}${encodeValues ? '?' : ''}${paramUrl}`, {
                method: method,
                headers: {
                    // 'Authorization': `Bearer ${token}`
                }
            })
            .then(data => {
                if(!data.ok) {
                    errors = true;
                }
                if (data.status === 204) return '';
                return data.json();
                
            })
            .then((response) => {
                if(errors) {
                    returnValue = response;
                    throw new Error(JSON.stringify(returnValue));
                }
                if (response.status === 204) return '';
                return response;
            })
            .catch(err => {throw new Error(err)})
        } 
        else {
            return fetch(`${process.env.REACT_APP_API}/${endpoint}`, {
                method: method,
                headers: 
                    {
                        // 'Authorization': `Bearer ${token}`,
                        // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    }
                ,
                body: encodeValues ? generateUrlParams(HttpMethod.Get, values) : values
            })
            .then(data => {
                if(!data.ok) {
                    errors = true;
                }
                if (data.status === 204) return '';
                return data.json();
            })
            .then((response) => {
                if(errors) {
                    returnValue = response;
                    throw new Error(returnValue)
                }
                if (response.status === 204) return '';
                return response;
            })
            .catch(err => {throw new Error(err)})
        };
    };
    return {
        get,
        post,
        put,
        del
    }
}
export default useAPI;